import CustomTable from '../../../elements/Table/CustomTable'
import React from 'react'

function PerformanceList(props) {
  const {list, fetch, fetching} = props

  const columns = [
    {Header: 'Employee', accessor: 'member.fn'},
    {Header: 'Requisitions', accessor: 'requisitions.total'},
    {Header: 'Purchase Order', accessor: 'purchaseOrder.total'},
    {Header: 'RFQ', accessor: 'rfq.total'},
    {Header: 'Remittance', accessor: 'remittance.total'},
    {Header: 'Vendor Quotes', accessor: 'vendorQuotes.total'},
    {Header: 'Vouchers', accessor: 'vouchers.total'},
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
    />
  )
}

export default PerformanceList
